import React, { useState, useEffect, useReducer } from 'react';
import cn from 'classnames';
import { Button } from '@UILayer/Inputs/Button';

// TYPES
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import { DOM_ID } from '@UILayer/UILayer.types';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX & MANAGERS
import { useAppSelector, useAppDispatch } from '@Managers/Redux/Hooks';
import { getWCAMode, setDebugTools } from '@Managers/Redux/AppState/AppState';
import ConfigLoader from '@ConfigLoader/ConfigLoader';

// IMAGES
import icon from './icon_debug.svg';
import icon_wca from './icon_debug_wca.svg';

const DebugPanelButton: React.FC<{}> = (props) => {
    const dispatch = useAppDispatch();
    const wcaMode = useAppSelector(getWCAMode);
    const image = wcaMode ? icon_wca : icon;

    const btnCN = cn(styles.square_btn, styles.red_btn, styles.debug_btn);

    useEffect(() => {}, []);

    function clickAction() {
        dispatch(setDebugTools(true));
    }

    return (
        <>
            {ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).debugTools?.active && (
                <Button id={DOM_ID.BUTTON_DEBUG_PANEL} className={btnCN} onChange={clickAction}>
                    <img src={image} alt="" />
                </Button>
            )}
        </>
    );
};

export default DebugPanelButton;
